module.exports = __webpack_public_path__ + "b7495d8b31616f2458f240f17bcf7224.svg";